<template>
  <div class="header">
    <div class="header_main">
      <p class="header-text">
        <img src="./img/logo.png" style="width: 50px; height: 50px" />
        三明市电子保函综合服务平台
      </p>
      <div class="drag_mue">
        <logo type="xiaoyanyun" href="/" style="margin-top: 20px"></logo>
        <h5
          class="zui-logo-text"
          style="color: black; margin-top: 22px; font-size: 15px"
        >
          三明市电子保函综合服务平台
        </h5>
        <div class="zui-rightcol" @click="openMenu" style="color: #0b8ba5">
          ◄目录►
        </div>
        <drop-list :config="configData" ref="droplist"></drop-list>
      </div>

      <div class="header_top hidden-xs-only">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          style="font-size: 15px"
        >
          <el-menu-item index="1">首页</el-menu-item>
          <el-menu-item index="2">保函产品</el-menu-item>
          <el-menu-item index="3">助贷服务</el-menu-item>
          <el-menu-item index="4">资讯中心 </el-menu-item>
          <el-menu-item index="5">保函查验</el-menu-item>
          <el-submenu index="6" popper-class="custom-service-popper">
            <template slot="title">服务入口</template>
            <el-menu-item index="6-1">用户端</el-menu-item>
            <el-menu-item index="6-2">保证金监管端</el-menu-item>
            <el-menu-item index="6-3">金融机构端</el-menu-item>
          </el-submenu>
         
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
import { gettoken, gettuserInfo } from "@/api/user";
import Cookies from "js-cookie";
import Logo from "./Logo";
import ZuiFooter from "./Footer";
import ZuiButton from "./Button";
import "./less/header.less";
import DropList from "vue-droplist";
export default {
  props: {
    active: {
      default: "1",
    },
  },
  watch: {
    active(newval, oldval) {
      if (newval) {
        this.activeIndex = newval;
        localStorage.setItem("active", newval);
      }
    },
  },
  components: { Logo, ZuiFooter, ZuiButton, DropList },
  data() {
    return {
      configData: {
        position: {
          // 设置显示位置，position
          top: "60px",
          right: "15px",
          bottom: "",
          left: "",
        },
        width: "40%", // 设置宽度
        list: [
          // 设置下拉列表数据和对应的点击事件
          { text: "首页", action: this.gohome },
          { text: "保函产品", action: this.goservice },
          { text: "助贷服务", action: this.goplan },
          { text: "资讯中心", action: this.gocase },
          { text: "保函查验", action: this.golink },
        ],
      },
      activeIndex: "1",
      userInfo: null,
    };
  },
  beforeMount() {
    this.activeIndex = localStorage.getItem("active") || "1";
  },
  mounted() {
    console.log(document.cookie, 111);

    if (!localStorage.getItem("token")) {
      console.log(Cookies.get());
      if (Cookies.get("userToken")) {
        this.gettoken();
      }
    }
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    } else {
      this.getUserInfo();
    }
  },
  methods: {
    gettoken() {
      gettoken({
        customerToken: Cookies.get("userToken"),
      }).then((res) => {
        localStorage.setItem("token", res.data.accessToken);
        localStorage.setItem("refreshToken", res.data.refreshToken);
        this.getUserInfo();
      });
    },
    getUserInfo() {
      gettuserInfo().then((res) => {
        this.userInfo = res.data;
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      });
    },
    onButtonClick: function (e) {
      if (e == "home") {
        this.$router.push({ path: "/" });
      } else if (e == "service") {
        this.$router.push({ path: "/Guarantee" });
      } else if (e == "about") {
        this.$router.push({ path: "/about" });
      } else if (e == "info") {
        this.$router.push({ path: "/info" });
      } else if (e == "help") {
        this.$router.push({ path: "/help" });
      } else if (e == "Business") {
        this.$router.push({ path: "/Business" });
      }
    },
    openMenu: function () {
      this.$refs.droplist.show();
    },
    gohome: function () {
      this.$router.push({ path: "/" });
    },
    goservice: function () {
      this.$router.push({ path: "/Guarantee" });
    },
    goplan: function () {
      this.$router.push({ path: "/about" });
    },
    gocase: function () {
      this.$router.push({ path: "/info" });
    },
    golink: function () {
      this.$router.push({ path: "/help" });
    },
    plan: function () {
      this.$router.push({ path: "/Business" });
    },
    handleSelect(e) {
      console.log(e);
      if (e == "1") {
        this.$router.push({ path: "/" });
      } else if (e == "2") {
        this.$router.push({ path: "/Guarantee" });
      } else if (e == "3") {
        this.$router.push({ path: "/about" });
      } else if (e == "4") {
        this.$router.push({ path: "/info" });
      } else if (e == "5") {
        this.$router.push({ path: "/help" });
      } else if (e == "6-1") {
        window.open(this.$Url + "/social-login");
      } else if (e == "6-2") {
        window.open(window.SITE_CONFIG.bzjUrl);
      } else if (e == "6-3") {
        window.open(window.SITE_CONFIG.kfptUrl);
      }

      this.activeIndex = e;
      localStorage.setItem("active", e);
    },
  },
};
</script>

<style scoped>
 /deep/ .el-menu .el-menu--popup .el-menu--popup-bottom-start {
  min-width: 130px !important;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .header-text {
    display: none;
  }
  .drag_mue {
    display: block;
    display: flex;
  }
  .zui-rightcol {
    margin-top: 5px;
    margin-left: 50px;
  }
}
@media screen and (min-width: 1024px) and (max-width: 3920px) {
  .header-text {
    display: block;
  }
  .drag_mue {
    display: none;
  }
}
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}
/deep/ .el-submenu__title {
  font-size: 18px !important;
}
/deep/ .el-menu-item {
  font-size: 18px !important;
}
.header {
  width: 100%;
  height: 70px;
  display: flex;
  line-height: 50px;
}
.header_main {
  position: relative;
  width: 90%;
  margin: auto;
  max-width: 1200px;
}
.header_top {
  position: absolute;
  right: 50px;
  top: 0px;
}
.header-text {
  font-size: 28px;
  font-weight: 500;
  color: #333333 !important;
  line-height: 70px;
  z-index: 50;
}
/deep/ .el-menu--horizontal > .el-menu-item.is-active {
  background: #1279eb !important;
  color: white !important;
  border: none;
}
/* 水平菜单 下拉框宽度缩小 */

/deep/ .el-menu-item {
  padding: 0;
  font-size: 15px !important;
  width: 78px !important;
  text-align: center;
  height: 70px !important;
  line-height: 70px !important;
  margin-right: 32px !important;
}
/* @media screen and (min-width: 376px) and (min-width:768px)  {
  .header_top {
        display: none
    }
} */
/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title{
  line-height: 66px;
  font-size: 15px !important;
  border-bottom: none !important;
  padding: 0 !important;
  font-size: 15px !important;
  width: 78px !important;
  text-align: center;
  height: 70px !important;
  line-height: 70px !important;
  margin-right: 32px !important;
  color: #909399;
}
/deep/ .el-submenu.is-active .el-submenu__title{
  border-bottom: none !important;
  padding: 0 !important;
  font-size: 15px !important;
  width: 78px !important;
  text-align: center;
  height: 70px !important;
  margin-right: 32px !important;
  color: #909399;
}

.login {
  width: 88px !important;
  height: 30px !important;
  border-radius: 100px 100px 100px 100px !important;
  opacity: 1 !important;
  border: 1px solid #1279eb !important;
  line-height: 30px !important;
  margin-top: 18px !important;
  color: #909399;
}
</style>
<style>
.custom-service-popper>.el-menu--popup{
  min-width: 130px !important;
 
}
</style>


// WEBPACK FOOTER //
// src/components/Headerbox.vue